import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
	padding-top: 100px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  padding: 0 10px;
	border-width: 2px;
	border-color: black;
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
	// padding: 1.5rem;
	padding-top: 3rem;
	// border-width: 0.25rem;
	// border-color: #9699b0;
	border-radius: 10px;
  animation: ${appearFromLeft} 1s;

  img {
    // border-radius: 50%;
    // margin-bottom: 20px;
  }

  @media (max-width: 650px) {
    img {
      width: 120px;
      height: 120px;
    }
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  h1 {
    padding: 10px;
  }

  @media (max-width: 650px) {
    h1 {
      font-size: 25px;
    }
  }
`;